import { render, staticRenderFns } from "./StickyHeader.vue?vue&type=template&id=535d5fef&scoped=true&"
import script from "./StickyHeader.vue?vue&type=script&lang=js&"
export * from "./StickyHeader.vue?vue&type=script&lang=js&"
import style0 from "./StickyHeader.vue?vue&type=style&index=0&id=535d5fef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d5fef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VLayout,VSpacer,VToolbarItems})
